<div class="body">
  <div class="container ">
    <div class="row title-box mt-3">
      <div class="col-12 col-sm-12">
        <h3 class="txtbienvenida">Administración de <span class="txtbienvenida-2">rangos de montos</span></h3>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-12 col-sm-12 mt-3">
        <p class="title-box">*Desde aqui puedes administrar los montos de crédito que quieres atender en la plataforma</p>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <form [formGroup]="adminMontosForm" class="custom-form row" (ngSubmit)="validateForm()">
        <div class="col-12 col-sm-4 mt-4">
          <div class="mb-3 required form-label" [ngClass]="{err: isValidForm('montoInicial')}">
            <label for="montoInicial" class="form-label">Monto inicial rango</label>
            <input placeholder="COP" type="text" maxlength="19" class="form-control" formControlName="montoInicial" [ngClass]="{'is-invalid':isValidForm('montoInicial')}" required>
            <div class="invalid-feedback">
              Campo obligatorio
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4 mt-4">
          <div class="mb-3 required form-label" [ngClass]="{err: isValidForm('montoFinal')}">
            <label for="montoFinal" class="form-label">Monto final rango</label>
            <input placeholder="COP" type="text" maxlength="19" class="form-control" formControlName="montoFinal" [ngClass]="{'is-invalid':isValidForm('montoFinal')}" required>
            <div class="invalid-feedback">
              Campo obligatorio
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4 align-self-center container-btn">
          <button type="submit" id="btn-agregar" class="btn btn-primary hvr-shrink">Agregar rango</button>
        </div>
      </form>
    </div>

    <div class="row mt-4 pr-3 pl-3">
      <div class="table-responsive">
        <table class="table table-striped table-borderless rounded">
          <thead class="table_head">
            <tr>
              <th scope="col" class="no-styles table-header" id="date-rango">Fecha de creación del rango</th>
              <th scope="col" class="no-styles table-header" id="date-rec">Monto inicial del rango</th>
              <th scope="col" class="no-styles table-header" id="solicitante">Monto final del rango</th>
              <th scope="col" class="no-styles table-header" id="doc">Modificar/Eliminar</th>
            </tr>
          </thead>
          <tbody>
            @for (monto of listaNeoMontosIntermediarioDTO; track monto; let i = $index) {
              <tr>
                <th scope="row" id="id-monto">{{monto.fechaCreacion | date: 'dd/MM/yyyy' : 'UTC'}}</th>
                <td>{{monto.montoInicial <999 ? "$ "+monto.montoInicial : monto.montoInicial | currency: 'USD'}} </td>
                <td>{{monto.montoFinal | currency:'USD'}}</td>
                <td><button id="btn-editar" type="button" class="hvr-shrink" data-bs-toggle="modal" data-bs-target="#editModal" (click)="editarFila(i)"><i class="fas fa-pencil-alt"></i></button>
                <button id="btn-borrar" type="button" class="hvr-shrink" (click)="borrarFila(i)">
                  <i class="fas fa-trash-alt"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col-12 col-sm-4 container-btn">
      <button class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="goHome()">Volver</button>
    </div>
  </div>
</div>


<!-- Modal -->
<div class="modal fade" id="editModal" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="editModalLabel">EDITAR RANGO DE MONTO</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

        </button>
      </div>
      <div class="modal-body-monto m-3">
        <form class="custom-form" [formGroup]="editarMontosForm">
          <div class="box-montos">
            <div class="mb-3 required text-start" [ngClass]="{err: isValidFormEditar( 'montoInicial')} ">
              <label for="montoInicial" class="form-label">Monto inicial rango</label>
              <input class="form-control box-number" maxlength="19 " type="text " formControlName="montoInicial" [ngClass]="{ 'is-invalid':isValidFormEditar( 'montoInicial')} " required>
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>
          </div>
          <div class="box-montos">
            <div class="mb-3 required text-start" [ngClass]="{err: isValidFormEditar( 'montoFinal')} ">
              <label for="montoFinal" class="form-label">Monto final rango</label>
              <input class="form-control box-number" maxlength="19" type="text" formControlName="montoFinal" [ngClass]="{ 'is-invalid':isValidFormEditar( 'montoFinal')} " required>
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>
          </div>
          <div class="box-montos">
            <div class="mb-3 required text-start" [ngClass]="{err: isValidFormEditar( 'justificacion')} ">
              <p>Justificación</p>
              <textarea maxlength="200" style="width: 100%;" rows="3 " type="text" formControlName="justificacion" [ngClass]="{ 'is-invalid':isValidFormEditar( 'justificacion')} " required></textarea>
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="editarRango()">Modificar rango</button>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->
<div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">BORRAR RANGO</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

        </button>
      </div>
      <div class="modal-body-monto m-3">
        <div class="box-montos">
          <div class="mb-3 required text-start">
            <p>Justificacion</p>
            <textarea maxlength="200" style="width: 100%;" rows="3" type="text" required name="justificacionDelete" [(ngModel)]="eliminarNeoMontoIntermediarioDTO.justificacion"></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="borrarRango()">Borrar Rango</button>
      </div>
    </div>
  </div>
</div>
<div class="footer-body"></div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
